import { NavType } from "./reducers/navbar";
import { FooterType } from "./reducers/footer";

export enum AppPath {
  ADMIN_USERS = "/adminusers",
  ROOT = "/",
  STATIC_CONTENTS = "/staticcontent",
  NOT_FOUND = "/not-found",
  SOFT_SKILLS_QUIZ = "/soft-skills-quiz",
  TERMS_AND_CONDITIONS = "/terms-and-conditions",
  PRIVACY_POLICY = "/privacy-policy",
  HOME_PAGE = "/",
  JOB_DESCRIPTION = "/job-description/:jobId",
  SIGN_IN = "/sign-in",
  SIGN_UP = "/sign-up",
  FIND_YOUR_JOY = "/find-your-joy",
  FIND_YOUR_JOY_CUSTOMER = "/find-your-joy-quiz",
  FORGOTTEN_PASSWORD = "/forgotten-password",
  SET_PASSWORD = "/set-password",
  DASHBOARD = "/dashboard",
  MEETINGS = "/meetings",
  REVIEW_VIDEO = "/review-video",
  RECORDED_INTERVIEW = "/recorded-interview",
  PRESENTATION_ACTIVITY = "/presentation-activity",
  BUSINESS_CASE_ACTIVITY = "/business-case-activity",
  REVIEW_ASSESSMENT = "/review-candidate",
  REVIEW_FEEDBACK_CANDIDATE = "/candidate-feedback",
  REVIEW_FEEDBACK_CLIENT = "/client-feedback",
  PERSONALITY_QUESTIONNAIRE = "/personality-questionnaire",
  DEVELOPMENT_ASSESSMENT = "/development-assessment",
  BUY_PQ_TESTS = "/buy-pq-tests",
  LIVE_APPLICATIONS = "/live-applications",
  HISTORIC_APPLICATIONS = "/historic-applications",
  BROWSE_OPPORTUNITIES = "/browse-opportunities",
  MESSAGES = "/messages",
  MY_DEVELOPMENT = "/my-development",
  PROFILE = "/profile",
  ACCOUNT = "/account",
  SETTINGS = "/settings",
  NOTIFICATIONS = "/notifications",
  PAYMENTS = "/payments",
  UPDATE_ABOUT = "/update-about",
  UPDATE_CONTACT = "/update-contact",
  UPDATE_EXPERIENCE = "/update-experience",
  UPDATE_EDUCATION = "/update-education",
  UPDATE_REFERENCES = "/update-references",
  VIRTUAL_TEAM_DISCUSSION = "/virtual-team-discussion",
  VIRTUAL_MEETING = "/virtual-meeting",
  LIVE_INTERVIEW = "/live-interview",
  CANDIDATE_AUTO_LOGIN = "/candidate-auto-login",
  ASSESSOR_AUTO_LOGIN = "/assessor-auto-login",
  LEARN_YOUR_STRENGTHS = "/learn-your-strengths",
  TEAM_STRENGTHS_REPORT = "/team-strengths-report",
  TEAM_STRENGTHS_GROUP_REPORT = "/team-strengths-group-report",
  JOY_AT_WORK_PROFILE_REPORT = "/joy-at-work-profile-report",
  ABILITY_TEST_RESULTS_PAGE = "/ability-test-report",
  RESOURCES = "/resources",
  SHARABLE_REPORT = "/sharable-report",
  RESET_PASSWORD = "/reset-password",
  SHARE_THE_JOY = "/share-the-joy",
}

export const paths = {
  dashboard: {
    url: AppPath.DASHBOARD,
    navType: NavType.LOGGED_IN,
    footerType: FooterType.NONE,
    data: null,
  },
  meetings: {
    url: AppPath.MEETINGS,
    navType: NavType.LOGGED_IN,
    footerType: FooterType.NONE,
    data: null,
  },
  reviewVideo: {
    url: AppPath.REVIEW_VIDEO,
    navType: NavType.LOGGED_IN,
    footerType: FooterType.NONE,
    data: null,
  },
  recordedInterview: {
    url: "/",
    navType: NavType.NONE,
    footerType: FooterType.NONE,
    data: null,
  },
  presentationActivity: {
    url: "/",
    navType: NavType.NONE,
    footerType: FooterType.NONE,
    data: null,
  },
  businessCaseActivity: {
    url: "/",
    navType: NavType.NONE,
    footerType: FooterType.NONE,
    data: null,
  },
  virtualTeamDiscussion: {
    url: "/",
    navType: NavType.NONE,
    footerType: FooterType.NONE,
    data: null,
  },
  virtualMeeting: {
    url: "/",
    navType: NavType.NONE,
    footerType: FooterType.NONE,
    data: null,
  },
  liveInterview: {
    url: "/",
    navType: NavType.NONE,
    footerType: FooterType.NONE,
    data: null,
  },
  recordedInterviewRoute: {
    url: AppPath.RECORDED_INTERVIEW,
    navType: NavType.LOGGED_IN,
    footerType: FooterType.NONE,
    data: null,
  },
  presentationActivityRoute: {
    url: AppPath.PRESENTATION_ACTIVITY,
    navType: NavType.LOGGED_IN,
    footerType: FooterType.NONE,
    data: null,
  },
  businessCaseActivityRoute: {
    url: AppPath.BUSINESS_CASE_ACTIVITY,
    navType: NavType.LOGGED_IN,
    footerType: FooterType.NONE,
    data: null,
  },
  virtualTeamDiscussionRoute: {
    url: AppPath.VIRTUAL_TEAM_DISCUSSION,
    navType: NavType.LOGGED_IN,
    footerType: FooterType.NONE,
    data: null,
  },
  virtualMeetingRoute: {
    url: AppPath.VIRTUAL_MEETING,
    navType: NavType.LOGGED_IN,
    footerType: FooterType.NONE,
    data: null,
  },
  liveInterviewRoute: {
    url: AppPath.LIVE_INTERVIEW,
    navType: NavType.LOGGED_IN,
    footerType: FooterType.NONE,
    data: null,
  },
  reviewAssessment: {
    url: AppPath.REVIEW_ASSESSMENT,
    navType: NavType.NONE,
    footerType: FooterType.NONE,
    data: null,
  },
  reviewFeedbackCandidate: {
    url: AppPath.REVIEW_FEEDBACK_CANDIDATE,
    navType: NavType.NONE,
    footerType: FooterType.NONE,
    data: null,
  },
  reviewFeedbackClient: {
    url: AppPath.REVIEW_FEEDBACK_CLIENT,
    navType: NavType.NONE,
    footerType: FooterType.NONE,
    data: null,
  },
  homePage: {
    url: AppPath.HOME_PAGE,
    navType: NavType.LOGIN,
    footerType: FooterType.LOGGED_IN,
    data: null,
  },
  privacyPolicyPage: {
    url: AppPath.PRIVACY_POLICY,
    navType: NavType.LOGIN,
    footerType: FooterType.LOGGED_IN,
    data: null,
  },
  signInPage: {
    url: AppPath.SIGN_IN,
    navType: NavType.LOGIN,
    footerType: FooterType.LOGGED_IN,
    data: null,
  },
  forgottenPasswordPage: {
    url: AppPath.FORGOTTEN_PASSWORD,
    navType: NavType.LOGIN,
    footerType: FooterType.LOGGED_IN,
    data: null,
  },
  resetPasswordPage: {
    url: AppPath.RESET_PASSWORD,
    navType: NavType.LOGIN,
    footerType: FooterType.LOGGED_IN,
    data: null,
  },
  setPasswordPage: {
    url: AppPath.SET_PASSWORD,
    navType: NavType.LOGIN,
    footerType: FooterType.LOGGED_IN,
    data: null,
  },
  termsAndConditionsPage: {
    url: AppPath.TERMS_AND_CONDITIONS,
    navType: NavType.LOGIN,
    footerType: FooterType.LOGGED_IN,
    data: null,
  },
  notFoundPage: {
    url: AppPath.TERMS_AND_CONDITIONS,
    navType: NavType.LOGIN,
    footerType: FooterType.LOGGED_IN,
    data: null,
  },
  adminUsers: {
    url: AppPath.ADMIN_USERS,
    navType: NavType.LOGIN,
    footerType: FooterType.LOGGED_IN,
    data: null,
  },
  staticContents: {
    url: AppPath.STATIC_CONTENTS,
    navType: NavType.NONE,
    footerType: FooterType.NONE,
    data: null,
  },
  landing: {
    url: AppPath.ROOT,
    navType: NavType.LOGIN,
    footerType: FooterType.NONE,
    data: null,
  },
  notFound: {
    url: AppPath.NOT_FOUND,
    navType: NavType.NONE,
    footerType: FooterType.NONE,
    data: null,
  },
  messages: {
    url: AppPath.MESSAGES,
    navType: NavType.LOGGED_IN,
    footerType: FooterType.NONE,
    data: null,
  },
};
